import React, { useState } from 'react';
import { DeleteEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { downloadImage } from '../media-container/media-container-utils.js';
import { NotFound } from '../not-found/not-found.js';
import { GalleryCard } from './card/gallery-card.js';
import { GalleryProperties } from './gallery-types.js';
import { useGalleryActions } from './hook/use-gallery-actions.js';
import './gallery.css';
function Gallery(props) {
    const [selectedCards, setSelectedCards] = useState(new Set());
    const addCard = (card) => {
        setSelectedCards((set) => {
            if (set.has(card)) {
                return set;
            }
            set.add(card);
            return new Set(set);
        });
    };
    const deleteCard = (card) => {
        setSelectedCards((set) => {
            if (!set.has(card)) {
                return set;
            }
            set.delete(card);
            return new Set(set);
        });
    };
    const getSelectables = () => {
        return Array.from(selectedCards.values());
    };
    const isSelectedCard = (card) => {
        return selectedCards.has(card);
    };
    const onSelectCard = (card) => {
        if (selectedCards.has(card)) {
            deleteCard(card);
        }
        else {
            addCard(card);
        }
    };
    const onUnselectAll = () => {
        setSelectedCards(new Set());
    };
    const onSelectAll = () => {
        for (const card of props.data ?? []) {
            addCard(card);
        }
    };
    const onDelete = () => {
        if (props.onDelete) {
            props.onDelete(new DeleteEvent({ id: getSelectables().map(card => card.id) }));
        }
    };
    const onDownload = () => {
        for (const selected of getSelectables()) {
            if (selected.image) {
                void downloadImage(selected.image);
            }
        }
    };
    useGalleryActions({
        onDelete,
        onDownload,
        onSelectAll,
        onUnselectAll,
        selectable: Boolean(props.selectable),
        selectedCards,
    });
    const { data = GalleryProperties.data.defaultValue, type = GalleryProperties.type.defaultValue, ...otherProps } = props;
    if (!data.length) {
        return React.createElement(NotFound, null);
    }
    return (React.createElement("div", { className: "c-gallery" },
        React.createElement("div", { className: "c-gallery__content" }, data.map((item, index) => (React.createElement(GalleryCard, { key: `gallery-card-${index}`, ...otherProps, ...item, onSelect: () => onSelectCard(item), selected: isSelectedCard(item), type: type }))))));
}
export { Gallery, };
//# sourceMappingURL=gallery.js.map